import React from 'react';
import { formatAppointmentDate, formatAppointmentTime } from '../../../utils/appointment-time';

export default function AppointmentInfo({ orderPackage }) {
  return (
    <div style={{ marginTop: '8px', marginBottom: '8px', fontWeight: 'bold' }}>
      Appointment Info:
      {' '}
      {formatAppointmentDate(orderPackage.appointmentTime, 'dddd, MMMM D')}
      {' '}
      at
      {' '}
      {formatAppointmentTime(orderPackage.appointmentTime)}
    </div>
  );
}
